import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { useTheme } from '../../../theming/useTheme';
import { style } from '../../../typography/typography.style';
import { createStyleForBoxShadow } from '../../../theming/boxShadow';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { getStyleBySize } from '../../../typography/semanticTags/semanticTags.utils';
import { TranslatedFontSize } from '../../../theming/fontSizeTranslator';

const componentConfigThemeKey = 'button';

interface ButtonProps {
  label: string | null;
  onClick: () => void;
  disabled?: boolean;
}

interface ButtonComponentThemeProps {
  backgroundColorEnabled: string;
  textColorEnabled: string;
  backgroundColorDisabled: string;
  textColorDisabled: string;
  borderRadius: number;
  boxShadowTypeNormal: string;
  boxShadowTypeHover: string;
  boxShadowTypeActive: string;
  boxShadowTypeDisable: string;
  baseUnit: BaseUnit;
  fontSizesStyles: TranslatedFontSize;

}

const getStyle = (backgroundColorEnabled: string, textColorEnabled: string, backgroundColorDisabled: string, textColorDisabled: string, baseUnit: BaseUnit, disabled: boolean, borderRadius: number) => {
  return StyleSheet.create({
    buttonStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: backgroundColorEnabled,
      color: disabled ? textColorDisabled : textColorEnabled,
      cursor: 'pointer',
      outline: 'none',
      border: 'none',
      padding: `${baseUnit / 4}px ${baseUnit / 2}px`,
      borderRadius: `${borderRadius}px`,
      ':disabled': {
        color: textColorDisabled,
        backgroundColor: backgroundColorDisabled,
        cursor: 'auto',
      },
    },
  });
};

export const Button: React.FunctionComponent<ButtonProps> = props => {
  const { backgroundColorEnabled, textColorEnabled, backgroundColorDisabled, textColorDisabled, baseUnit, borderRadius, boxShadowTypeActive, boxShadowTypeDisable, boxShadowTypeHover, boxShadowTypeNormal, fontSizesStyles } = useTheme<ButtonComponentThemeProps>(componentConfigThemeKey);
  const { label, onClick, disabled = false } = props;
  const buttonStyle = getStyle(backgroundColorEnabled, textColorEnabled, backgroundColorDisabled, textColorDisabled, baseUnit, disabled, borderRadius);
  const boxShadowStyle = createStyleForBoxShadow({ boxShadowTypeNormal, boxShadowTypeHover, boxShadowTypeActive, boxShadowTypeDisable });
  const textStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL, fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL, fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL });
  return (
    <button
      type="button"
      disabled={disabled}
      className={css(
        buttonStyle.buttonStyle,
        boxShadowStyle.style,
        StyleSheet.create({ style }).style,
        textStyle,
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
};
